/*
 * 静态 cluster → 业务接口域名映射（对齐 timemark.com 的 src/constants/clusters.ts）。
 *
 * app.dayscamera.com 域名已下线，统一改用 app.timemark.com 系。
 * center 与 sg 集群共用同一域名，仅 us 集群使用独立域名。
 */
const isEnvTest = process.env.NODE_ENV === 'test'
const isEnvProduction = process.env.NODE_ENV === 'production'
const isEnvStaging = process.env.NODE_ENV === 'staging'

export const DEFAULT_CLUSTER = 'sg'

function getClusterEndpoints() {
  if (isEnvProduction) {
    return {
      sg: 'https://app.timemark.com',
      us: 'https://app-us.timemark.com'
    }
  }
  if (isEnvStaging) {
    return {
      sg: 'https://app-staging.timemark.com',
      us: 'https://app-us-staging.timemark.com'
    }
  }
  if (isEnvTest) {
    return {
      sg: 'https://app-test.timemark.com',
      us: 'https://app-us-test.timemark.com'
    }
  }
  return {
    sg: 'https://app-test.timemark.com',
    us: 'https://app-us-test.timemark.com'
  }
}

/**
 * 根据 cluster 名称解析业务接口域名；未知/缺失 cluster（旧版本 App 生成的链接不带
 * cluster 参数）回退到默认集群（sg）。
 *
 * @param {string|null|undefined} cluster
 * @returns {string}
 */
export function resolveClusterEndpoint(cluster) {
  const endpoints = getClusterEndpoints()
  const key = cluster || DEFAULT_CLUSTER
  return endpoints[key] || endpoints[DEFAULT_CLUSTER]
}
